import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { FeApi, useInjectFeApiContext } from '@/api/fe-api';

import type { Task } from '../entities/task';
import type { Workstream } from '../entities/workstream';

export namespace LinkTaskMutation {
  export type Input = {
    siteId: string;
    workstreamId: Workstream['id'];
    taskId: Task['id'];
  };
  export type Output = void;

  function useMutationFn() {
    const linkTask = useInjectFeApiContext(
      FeApi.tasksV1WorkstreamsAttachCardCreate,
    );

    return async function mutationFn(input: Input) {
      await ok(
        linkTask({
          uuid: input.workstreamId,
          attachCardToWorkstreamViewInputRequest: {
            card_uuid: input.taskId,
          },
        }),
      );
    };
  }

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const mutationFn = useMutationFn();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn,
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: ['project-management'],
        });
      },
    });
  }
}
